module.exports = __webpack_public_path__ + "static/media/1018966.817be2f0.jpg";